import { Box, Grid, Skeleton } from '@mui/material';
import _ from 'lodash';

export const RegisterAdminSuccessSkeleton: React.FC = () => {
  return (
    <Box sx={{ my: 7.5 }} className="container-fluid">
      <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <Skeleton sx={{ mb: 5 }} variant="rectangular" height="12.5rem" width="12.5rem" />
        <Skeleton variant="text" width="min(100%, 50rem)" height="1.5rem" />
        <Skeleton variant="text" width="min(90%, 40rem)" height="1.5rem" />
      </Box>
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={10} md={8} lg={6} xl={4}>
          <Box sx={{ mt: 5, border: 1, borderRadius: 1, p: 5, borderColor: 'grey.200' }}>
            <Skeleton variant="text" width="10rem" sx={{ mx: 'auto', mb: 4 }} />
            <Skeleton variant="rectangular" height="1.5rem" width="7.5rem" sx={{ mb: 2 }} />
            {_.times(2).map((_item, index) => (
              <Grid container key={index} spacing={1}>
                <Grid item>
                  <Skeleton variant="text" width="5rem" />
                </Grid>
                <Grid item>
                  <Skeleton variant="text" width="15rem" />
                </Grid>
              </Grid>
            ))}
            <Box sx={{ mt: 5 }}>
              <Skeleton variant="rectangular" height="1.5rem" width="7.5rem" sx={{ mb: 2 }} />
              <Box sx={{ p: 2.5, bgcolor: 'grey.50', borderRadius: 1, display: 'inline-block', mb: 2.5 }}>
                <Grid container spacing={3}>
                  <Grid item>
                    <Skeleton variant="circular" height="2.5rem" width="2.5rem" />
                  </Grid>
                  <Grid item>
                    <Skeleton variant="text" height="1.5rem" width="7.5rem" />
                    <Skeleton variant="text" height="1rem" width="12rem" />
                  </Grid>
                </Grid>
              </Box>
              {_.times(3).map((_item, index) => (
                <Grid container key={index} spacing={1}>
                  <Grid item>
                    <Skeleton variant="text" width="5rem" />
                  </Grid>
                  <Grid item>
                    <Skeleton variant="text" width="15rem" />
                  </Grid>
                </Grid>
              ))}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
